import { render, staticRenderFns } from "./TransporterRegister.vue?vue&type=template&id=da8ec3e8&scoped=true&"
import script from "./TransporterRegister.vue?vue&type=script&lang=js&"
export * from "./TransporterRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ec3e8",
  null
  
)

export default component.exports